import { render, staticRenderFns } from "./addRuleModal.vue?vue&type=template&id=f4cd76be&"
import script from "./addRuleModal.vue?vue&type=script&lang=ts&"
export * from "./addRuleModal.vue?vue&type=script&lang=ts&"
import style0 from "./addRuleModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports